<div class="recording-management-page-header" onsip-grid-placement-shell-navigation>
  <h1 class="first-header-column">{{ "ONSIP_I18N.RECORDING_MANAGER" | translate }}</h1>
  <div class="mat-body-2 subtitle second-header-column">
    {{
      "ONSIP_I18N.DIAL_AN_EXTENSIONS_OR_PRONE_NUMBER_TO_RECORD_AND_UPDATE_BROADCAST_MESSAGES"
        | translate
    }}
  </div>
</div>
<onsip-loading-container [deferCond]="isLoaded$">
  @if (recManagement$ | async) { @if ((voicePanel$ | async) === 'view') {
  <onsip-recording-manager-view
    [recManager]="(recManagement$ | async)!"
    (editPanel)="togglePanel('edit')"
  ></onsip-recording-manager-view>
  } @if ((voicePanel$ | async) === 'edit') {
  <onsip-recording-manager-edit
    [recManager]="(recManagement$ | async)!"
    (editPanel)="togglePanel('view')"
  ></onsip-recording-manager-edit>
  } }
  <div class="mat-body-2 contact-support">
    {{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
    <a class="support-link" [routerLink]="[views.CONTACT_SUPPORT]">
      {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
    </a>
  </div>
</onsip-loading-container>
